import { ECN_TRADE_SYMBOL_SUMMARY, ECN_TRADE_MMID_SUMMARY,
  ECN_ORDER_SYMBOL_SUMMARY, ECN_ORDER_MMID_SUMMARY, ECN_OPEN_ORDER_SYMBOL_SUMMARY, ECN_OPEN_ORDER_MMID_SUMMARY,
  ECN_UNENTITLED_SYMBOLS_SUMMARY, ECN_ORDER_TRADE_RATIO_SUMMARY,
  IDQS_DAY_TRADE_SYMBOL_SUMMARY, IDQS_DAY_TRADE_MMID_SUMMARY, IDQS_DAY_ORDER_SYMBOL_SUMMARY, IDQS_DAY_ORDER_MMID_SUMMARY,
  IDQS_DAY_OPEN_ORDER_SYMBOL_SUMMARY, IDQS_DAY_OPEN_ORDER_MMID_SUMMARY, IDQS_DAY_UNENTITLED_SYMBOLS_SUMMARY, IDQS_DAY_ORDER_TRADE_RATIO_SUMMARY,
  IDQS_NIGHT_TRADE_SYMBOL_SUMMARY, IDQS_NIGHT_TRADE_MMID_SUMMARY, IDQS_NIGHT_ORDER_SYMBOL_SUMMARY, IDQS_NIGHT_ORDER_MMID_SUMMARY,
  IDQS_NIGHT_OPEN_ORDER_SYMBOL_SUMMARY, IDQS_NIGHT_OPEN_ORDER_MMID_SUMMARY, IDQS_NIGHT_UNENTITLED_SYMBOLS_SUMMARY, IDQS_NIGHT_ORDER_TRADE_RATIO_SUMMARY,
  IDQS_NMS_TRADE_SYMBOL_SUMMARY, IDQS_NMS_TRADE_MMID_SUMMARY, IDQS_NMS_ORDER_SYMBOL_SUMMARY, IDQS_NMS_ORDER_MMID_SUMMARY,
  IDQS_NMS_OPEN_ORDER_SYMBOL_SUMMARY, IDQS_NMS_OPEN_ORDER_MMID_SUMMARY, IDQS_NMS_UNENTITLED_SYMBOLS_SUMMARY, IDQS_NMS_ORDER_TRADE_RATIO_SUMMARY,
  ATS_TRADE_SYMBOL_SUMMARY, ATS_TRADE_MMID_SUMMARY, ATS_QUOTE_SYMBOL_SUMMARY, ATS_QUOTE_MMID_SUMMARY,
  ATS_QUOTE_FREQ_SYMBOL_SUMMARY, ATS_QUOTE_FREQ_MMID_SUMMARY,
  TDDS_NOTIONAL_RATIO_SUMMARY, TDDS_SHARE_RATIO_SUMMARY, TDDS_TRADE_RATIO_SUMMARY,
  ECN_RISK_SUMMARY,IDQS_RISK_SUMMARY, UNMATCHED_TRADES, UNMATCHED_OTHER_TRADES, LOCK_CROSS_QUOTES, L1_TRADES, TRF_TRADES,
  ORDERS_COLUMN, TRADES_COLUMN, QUOTES_COLUMN, VOLUME_COLUMN, NOTIONAL_COLUMN, NOTIONAL_VALUE_COLUMN, OPEN_ORDERS_COLUMN,
  TRADE_DATE_COLUMN, CUST_ORD_ID_COLUMN, CONTRA_ORD_ID_COLUMN, AVG_PRICE_COLUMN, CUM_QTY_COLUMN, TRADE_EXEC_ID_COLUMN, TEXT_COLUMN,
  SYMBOL_COLUMN, MMID_COLUMN, MPID_COLUMN, ORDERS_TRADE_RATIO_COLUMN,
  SENDER_MPID_COLUMN, RECEIVER_MPID_COLUMN, TRADE_TIME_COLUMN, TRADE_CLOSE_TIME_COLUMN, QUOTE_INSIDE_PRICE_COLUMN, TRADE_PRICE_COLUMN,
  OTCXN_TRADE_COLUMN, OTCXN_TRADE_RATIO_COLUMN, ATS_TRADE_COLUMN, ATS_TRADE_RATIO_COLUMN, TDDS_TRADE_COLUMN,
  OTCXN_SHARE_COLUMN, OTCXN_SHARE_RATIO_COLUMN, ATS_SHARE_COLUMN, ATS_SHARE_RATIO_COLUMN, TDDS_SHARE_COLUMN,
  OTCXN_NOTIONAL_COLUMN, OTCXN_NOTIONAL_RATIO_COLUMN, ATS_NOTIONAL_COLUMN, ATS_NOTIONAL_RATIO_COLUMN, TDDS_NOTIONAL_COLUMN,
  EXEC_TINE_COLUMN, CONTRA_BROKER_COLUMN, SECURITY_COLUMN, SIDE_COLUMN, CL_ORID_COLUMN, EXEC_PRICE_COLUMN, EXEC_QTY_COLUMN, 
  SYSTEM_INTERNAL_ID_COLUMN, SYSTEM_ACK_COLUMN, CLIENT_EXEC_ID_COLUMN, DURATION_COLUMN, TRADE_ID_COLUMN, USER_ACK_COLUMN, TRADE_DATE_TIME_COLUMN,
  TRADE_OG_QTY_COLUMN, TRADE_STATE_COLUMN,
  PRICE_COLUMN, INSIDE_PRICE_COLUMN, LOCK_CROSS_TIME_COLUMN, RESOLVED_ALERT_COLUMN
} from '../src/util/dashBoardPageConstants';

const isStage = _ => window.location.host.match(/stage/) || window.location.host.match(/stg/) || window.location.host.match(/47896b57-138f-44f1-96ae-52cc6e28194b/)
const isProd = _ => window.location.host.match(/prod/) || window.location.host.match(/41158628-8faf-4a74-ae42-1f301fb7bd3a/)

const getEnv = () => {
  if (window.location.host.match(/localhost/)) {
    return 'local';
  } else if (window.location.host.match(/dev/)) {
    return 'dev';
  } else if (window.location.host.match(/test/)) {
    return 'test';
  } else if (window.location.host.match(/qa/)) {
    return 'qa';
  } else if (isStage()) {
    return 'stage';
  }
};


const getTradeHeaderWebSocket = () => {
  if (window.location.host.match(/localhost/)) {
    return 'wss://tps-realtime.dev.otcmkt.com';
  } else if (window.location.host.match(/dev/)) {
    return 'wss://tps-realtime.dev.otcmkt.com';
  } else if (window.location.host.match(/test/)) {
    return 'wss://tps-realtime.test.otcmkt.com';
  } else if (window.location.host.match(/qa/)) {
    return 'wss://tps-realtime.test.otcmkt.com';
  } else if (isStage()) {
    return 'wss://tps-realtime.stage.otcmkt.com';
  } else if (isProd()) {
    return 'wss://tps-realtime.prod.otcmkt.com';
  }
};

const getEcnWebSocket = () => {
  if (window.location.host.match(/localhost/)) {
    return 'wss://ecn-market-data-service.dev.otcmkt.com/ws/ecn/trade/summary';
  } else if (window.location.host.match(/dev/)) {
    return 'wss://ecn-market-data-service.dev.otcmkt.com/ws/ecn/trade/summary';
  } else if (window.location.host.match(/test/)) {
    return 'wss://ecn-market-data-service.test.otcmkt.com/ws/ecn/trade/summary';
  } else if (window.location.host.match(/qa/)) {
    return 'wss://ecn-market-data-service.dev.otcmkt.com/ws/ecn/trade/summary';
  } else if (isStage()) {
    return 'wss://ecn-market-data-service.stage.otcmkt.com/ws/ecn/trade/summary';
  } else if (isProd()) {
    return 'wss://ecn-market-data-service.prod.otcmkt.com/ws/ecn/trade/summary';
  }
};

const getAtsWebSocket = () => {
  if (window.location.host.match(/localhost/)) {
    return 'wss://ecn-market-data-service.dev.otcmkt.com/ws/ats/trade/summary';
  } else if (window.location.host.match(/dev/)) {
    return 'wss://ecn-market-data-service.dev.otcmkt.com/ws/ats/trade/summary';
  } else if (window.location.host.match(/test/)) {
    return 'wss://ecn-market-data-service.test.otcmkt.com/ws/ats/trade/summary';
  } else if (window.location.host.match(/qa/)) {
    return 'wss://ecn-market-data-service.test.otcmkt.com/ws/ats/trade/summary';
  } else if (isStage()) {
    return 'wss://ecn-market-data-service.stage.otcmkt.com/ws/ats/trade/summary';
  } else if (isProd()) {
    return 'wss://ecn-market-data-service.prod.otcmkt.com/ws/ats/trade/summary';
  }
};

const getIdqsWebSocket = () => {
  if (window.location.host.match(/localhost/)) {
    return 'wss://ecn-market-data-service.dev.otcmkt.com/ws/idqs/trade/summary';
  } else if (window.location.host.match(/dev/)) {
    return 'wss://ecn-market-data-service.dev.otcmkt.com/ws/idqs/trade/summary';
  } else if (window.location.host.match(/test/)) {
    return 'wss://ecn-market-data-service.test.otcmkt.com/ws/idqs/trade/summary';
  } else if (window.location.host.match(/qa/)) {
    return 'wss://ecn-market-data-service.test.otcmkt.com/ws/idqs/trade/summary';
  } else if (isStage()) {
    return 'wss://ecn-market-data-service.stage.otcmkt.com/ws/idqs/trade/summary';
  } else if (isProd()) {
    return 'wss://ecn-market-data-service.prod.otcmkt.com/ws/idqs/trade/summary';
  }
};

const getIdqsNightWebSocket = () => {
  if (window.location.host.match(/localhost/)) {
    return 'wss://ecn-market-data-service.dev.otcmkt.com/ws/idqs/overnight/trade/summary';
  } else if (window.location.host.match(/dev/)) {
    return 'wss://ecn-market-data-service.dev.otcmkt.com/ws/idqs/overnight/trade/summary';
  } else if (window.location.host.match(/test/)) {
    return 'wss://ecn-market-data-service.test.otcmkt.com/ws/idqs/overnight/trade/summary';
  } else if (window.location.host.match(/qa/)) {
    return 'wss://ecn-market-data-service.test.otcmkt.com/ws/idqs/overnight/trade/summary';
  } else if (isStage()) {
    return 'wss://ecn-market-data-service.stage.otcmkt.com/ws/idqs/overnight/trade/summary';
  } else if (isProd()) {
    return 'wss://ecn-market-data-service.prod.otcmkt.com/ws/idqs/overnight/trade/summary';
  }
};
const getIdqsNmstWebSocket = () => {
  if (window.location.host.match(/localhost/)) {
    return 'wss://ecn-market-data-service.dev.otcmkt.com/ws/idqs/moon/trade/summary';
  } else if (window.location.host.match(/dev/)) {
    return 'wss://ecn-market-data-service.dev.otcmkt.com/ws/idqs/moon/trade/summary';
  } else if (window.location.host.match(/test/)) {
    return 'wss://ecn-market-data-service.test.otcmkt.com/ws/idqs/moon/trade/summary';
  } else if (window.location.host.match(/qa/)) {
    return 'wss://ecn-market-data-service.test.otcmkt.com/ws/idqs/moon/trade/summary';
  } else if (isStage()) {
    return 'wss://ecn-market-data-service.stage.otcmkt.com/ws/idqs/moon/trade/summary';
  } else if (isProd()) {
    return 'wss://ecn-market-data-service.prod.otcmkt.com/ws/idqs/moon/trade/summary';
  }
};

const getTddsWebSocket = () => {
  if (window.location.host.match(/localhost/)) {
    return 'wss://ecn-market-data-service.dev.otcmkt.com/ws/tdds/trade/summary';
  } else if (window.location.host.match(/dev/)) {
    return 'wss://ecn-market-data-service.dev.otcmkt.com/ws/tdds/trade/summary';
  } else if (window.location.host.match(/test/)) {
    return 'wss://ecn-market-data-service.test.otcmkt.com/ws/tdds/trade/summary';
  } else if (window.location.host.match(/qa/)) {
    return 'wss://ecn-market-data-service.test.otcmkt.com/ws/tdds/trade/summary';
  } else if (isStage()) {
    return 'wss://ecn-market-data-service.stage.otcmkt.com/ws/tdds/trade/summary';
  } else if (isProd()) {
    return 'wss://ecn-market-data-service.prod.otcmkt.com/ws/tdds/trade/summary';
  }
};

const getRiskNotificationWebSocket = () => {
  if (window.location.host.match(/localhost/)) {
    return 'wss://tps-alerting-service.dev.otcmkt.com/ws/risk/notification';
  } else if (window.location.host.match(/dev/)) {
    return 'wss://tps-alerting-service.dev.otcmkt.com/ws/risk/notification';
  } else if (window.location.host.match(/test/)) {
    return 'wss://tps-alerting-service.test.otcmkt.com/ws/risk/notification';
  } else if (window.location.host.match(/qa/)) {
    return 'wss://tps-alerting-service.test.otcmkt.com/ws/risk/notification';
  } else if (window.location.host.match(/stage/)) {
    return 'wss://tps-alerting-service.stage.otcmkt.com/ws/risk/notification';
  } else if (window.location.host.match(/prod/)) {
    return 'wss://tps-alerting-service.prod.otcmkt.com/ws/risk/notification';
  }
};

const getDashboardConfig = () => {
  if (window.location.host.match(/localhost/)) {
    return getDashboardTableConfig('ecn-market-data-service.dev.otcmkt.com');
  } else if (window.location.host.match(/dev/)) {
    return getDashboardTableConfig('ecn-market-data-service.dev.otcmkt.com');
  } else if (window.location.host.match(/test/)) {
    return getDashboardTableConfig('ecn-market-data-service.test.otcmkt.com');
  } else if (window.location.host.match(/qa/)) {
    return getDashboardTableConfig('ecn-market-data-service.test.otcmkt.com');
  } else if (isStage()) {
    return getDashboardTableConfig('ecn-market-data-service.stage.otcmkt.com');
  } else if (isProd()) {
    return getDashboardTableConfig('ecn-market-data-service.prod.otcmkt.com');
  }
};

const getRiskDataConfig = () => {
  if (window.location.host.match(/localhost/)) {
    return getRiskDashboardTableConfig('tps-alerting-service.dev.otcmkt.com');
  } else if (window.location.host.match(/dev/)) {
    return getRiskDashboardTableConfig('tps-alerting-service.dev.otcmkt.com');
  } else if (window.location.host.match(/test/)) {
    return getRiskDashboardTableConfig('tps-alerting-service.test.otcmkt.com');
  } else if (window.location.host.match(/qa/)) {
    return getRiskDashboardTableConfig('tps-alerting-service.test.otcmkt.com');
  } else if (window.location.host.match(/stage/)) {
    return getRiskDashboardTableConfig('tps-alerting-service.stage.otcmkt.com');
  } else if (window.location.host.match(/prod/)) {
    return getRiskDashboardTableConfig('tps-alerting-service.prod.otcmkt.com');
  }
};

const getConfig = () => {
  // Use env vars as default
  return {
    REACT_ENV: getEnv(),
    TRADE_HEADER_WEB_SOCKET_API: getTradeHeaderWebSocket(),
    //ECN_WEB_SOCKET_API: getEcnWebSocket(),
    //ATS_WEB_SOCKET_API: getAtsWebSocket(),
    //IDQS_WEB_SOCKET_API: getIdqsWebSocket(),
    //IDQS_NIGHT_WEB_SOCKET_API: getIdqsNightWebSocket(),
    //IDQS_NMS_WEB_SOCKET_API: getIdqsNmstWebSocket(),
    //TDDS_WEB_SOCKET_API: getTddsWebSocket(),
    DASHBOARD_CONFIG: getDashboardConfig(),
    RISK_DASHBOARD_CONFIG: getRiskDataConfig(),
    RISK_NOTIFICATION_WEB_SOCKET_API: getRiskNotificationWebSocket(),
    REACT_APP_API_BASE_URI: process.env.REACT_APP_API_BASE_URI || ''
  };
};
const getRiskDashboardTableConfig = (internalApiUrl) => {
  const map = new Map();
  const ECN_RISK_CONFIG = {
    identifier: ECN_RISK_SUMMARY,
    ws: `wss://${internalApiUrl}/ws/risk/ecn/alert`,// TPS ALERT API
    api: '/internal/risk-dashboard-live-data/risk/ecn/alert', // TPS ALERT API
    historicApi: '/internal/risk-dashboard-hist-data/risk/ecn/alert/historic', // TPS API
    downloadApi: '/internal/risk-dashboard-hist-data/download/risk/ecn/alert/historic/download', // TPS API
    lastUpdatedField: 'latestProcessingTime',
    totalField: 'totalAlerts',
    summaryGroupTitleColumn: EXEC_TINE_COLUMN,
    summaryGroupDataColumn: MPID_COLUMN,
    header: 'Exceptions',
    histColumns: [EXEC_TINE_COLUMN, MPID_COLUMN, CONTRA_BROKER_COLUMN, SECURITY_COLUMN, SIDE_COLUMN, CL_ORID_COLUMN, EXEC_PRICE_COLUMN, EXEC_QTY_COLUMN, CLIENT_EXEC_ID_COLUMN, SYSTEM_INTERNAL_ID_COLUMN, SYSTEM_ACK_COLUMN],
    columns: [EXEC_TINE_COLUMN, MPID_COLUMN, CONTRA_BROKER_COLUMN, SECURITY_COLUMN, SIDE_COLUMN, CL_ORID_COLUMN, EXEC_PRICE_COLUMN, EXEC_QTY_COLUMN, CLIENT_EXEC_ID_COLUMN, SYSTEM_INTERNAL_ID_COLUMN, SYSTEM_ACK_COLUMN, USER_ACK_COLUMN]

  }
  const IDQS_RISK_CONFIG = {
    identifier: IDQS_RISK_SUMMARY,
    ws: `wss://${internalApiUrl}/ws/risk/idqs/alert`, // TPS ALERT API
    api: '/internal/risk-dashboard-live-data/risk/idqs/alert',// TPS ALERT API
    historicApi: '/internal/risk-dashboard-hist-data/risk/idqs/alert/historic', // TPS API
    downloadApi: '/internal/risk-dashboard-hist-data/download/risk/idqs/alert/historic/download', // TPS API
    lastUpdatedField: 'latestProcessingTime',
    totalField: 'totalAlerts',
    summaryGroupTitleColumn: EXEC_TINE_COLUMN,
    summaryGroupDataColumn: MPID_COLUMN,
    header: 'Exceptions',
    histColumns: [EXEC_TINE_COLUMN, MPID_COLUMN, CONTRA_BROKER_COLUMN, SECURITY_COLUMN, SIDE_COLUMN, CL_ORID_COLUMN, EXEC_PRICE_COLUMN, EXEC_QTY_COLUMN, CLIENT_EXEC_ID_COLUMN, SYSTEM_INTERNAL_ID_COLUMN, SYSTEM_ACK_COLUMN],
    columns: [EXEC_TINE_COLUMN, MPID_COLUMN, CONTRA_BROKER_COLUMN, SECURITY_COLUMN, SIDE_COLUMN, CL_ORID_COLUMN, EXEC_PRICE_COLUMN, EXEC_QTY_COLUMN, CLIENT_EXEC_ID_COLUMN, SYSTEM_INTERNAL_ID_COLUMN, SYSTEM_ACK_COLUMN, USER_ACK_COLUMN]

  }

  const UNMATCHED_TRADES_CONFIG = {
    identifier: UNMATCHED_TRADES,
    ws: `wss://${internalApiUrl}/ws/risk/orf/alert`, // TPS ALERT API
    api: '/internal/risk-dashboard-live-data/risk/orf/alert',// TPS ALERT API
    downloadApi: '/internal/risk-dashboard-hist-data/download/risk/orf/alert/historic/download', // TPS API
    lastUpdatedField: 'latestProcessingTime',
    totalField: 'openAlerts',
    summaryGroupTitleColumn: TRADE_ID_COLUMN,
    summaryGroupDataColumn: SYMBOL_COLUMN,
    header: 'Unmatched Trades',
    columns: [TRADE_ID_COLUMN, SYMBOL_COLUMN, SIDE_COLUMN, EXEC_PRICE_COLUMN, EXEC_QTY_COLUMN, NOTIONAL_COLUMN, DURATION_COLUMN, USER_ACK_COLUMN]

  }

  const UNMATCHED_OTHER_TRADES_CONFIG = {
    identifier: UNMATCHED_OTHER_TRADES,
    ws: `wss://${internalApiUrl}/ws/risk/orf/other/alert`, // TPS ALERT API
    api: '/internal/risk-dashboard-live-data/risk/orf/other/alert',// TPS ALERT API
    downloadApi: '/internal/risk-dashboard-hist-data/download/risk/orf/other/alert/historic/download', // TPS API
    lastUpdatedField: 'latestProcessingTime',
    totalField: 'openAlerts',
    summaryGroupTitleColumn: TRADE_DATE_TIME_COLUMN,
    summaryGroupDataColumn: TRADE_ID_COLUMN,
    header: 'Unmatched Trades',
    columns: [TRADE_DATE_TIME_COLUMN, TRADE_ID_COLUMN, SYMBOL_COLUMN, SIDE_COLUMN, EXEC_PRICE_COLUMN, EXEC_QTY_COLUMN, NOTIONAL_COLUMN]

  }
  
  const LOCK_CROSS_QUOTES_CONFIG = {
    identifier: LOCK_CROSS_QUOTES,
    ws: `wss://${internalApiUrl}/ws/risk/lock-cross/alert`, // TPS ALERT API
    api: '/internal/risk-dashboard-live-data/risk/lock-cross/alert',// TPS ALERT API
    downloadApi: '/internal/risk-dashboard-hist-data/download/risk/lock-cross/alert/historic/download', // TPS API
    lastUpdatedField: 'latestProcessingTime',
    totalField: 'openAlerts',
    summaryGroupTitleColumn: LOCK_CROSS_TIME_COLUMN,
    summaryGroupDataColumn: MPID_COLUMN,
    header: 'Events',
   // histColumns: [EXEC_TINE_COLUMN, MPID_COLUMN, CONTRA_BROKER_COLUMN, SECURITY_COLUMN, SIDE_COLUMN, CL_ORID_COLUMN, EXEC_PRICE_COLUMN, EXEC_QTY_COLUMN, CLIENT_EXEC_ID_COLUMN, SYSTEM_INTERNAL_ID_COLUMN, SYSTEM_ACK_COLUMN],
    columns: [LOCK_CROSS_TIME_COLUMN, MPID_COLUMN, SYMBOL_COLUMN, SIDE_COLUMN, PRICE_COLUMN, INSIDE_PRICE_COLUMN, DURATION_COLUMN, RESOLVED_ALERT_COLUMN, USER_ACK_COLUMN]
  }

  const L1_TRADES_CONFIG = {
    identifier: L1_TRADES,
    ws: `wss://${internalApiUrl}/ws/risk/l1/alert`, // TPS ALERT API
    api: '/internal/risk-dashboard-live-data/risk/l1/alert',// TPS ALERT API
    downloadApi: '/internal/risk-dashboard-hist-data/download/risk/l1/alert/historic/download', // TPS API
    lastUpdatedField: 'latestProcessingTime',
    totalField: 'openAlerts',
    summaryGroupTitleColumn: TRADE_ID_COLUMN,
    summaryGroupDataColumn: SENDER_MPID_COLUMN,
    header: 'Alerts',
    columns: [TRADE_ID_COLUMN, SENDER_MPID_COLUMN, RECEIVER_MPID_COLUMN, SIDE_COLUMN, SYMBOL_COLUMN, TRADE_PRICE_COLUMN, TRADE_OG_QTY_COLUMN, NOTIONAL_COLUMN, TRADE_TIME_COLUMN, TRADE_CLOSE_TIME_COLUMN, TRADE_STATE_COLUMN, QUOTE_INSIDE_PRICE_COLUMN, USER_ACK_COLUMN]
  }

  const TRF_TRADES_CONFIG = {
    identifier: TRF_TRADES,
    ws: `wss://${internalApiUrl}/ws/risk/trf/alert`, // TPS ALERT API
    api: '/internal/risk-dashboard-live-data/risk/trf/alert',// TPS ALERT API
    downloadApi: '/internal/risk-dashboard-hist-data/download/risk/trf/alert/historic/download', // TPS API
    lastUpdatedField: 'latestProcessingTime',
    totalField: 'openAlerts',
    summaryGroupTitleColumn: TRADE_DATE_COLUMN,
    summaryGroupDataColumn: EXEC_TINE_COLUMN,
    header: 'Unmatched Trades',
    columns: [TRADE_DATE_COLUMN, EXEC_TINE_COLUMN, TRADE_EXEC_ID_COLUMN, CUST_ORD_ID_COLUMN, CONTRA_ORD_ID_COLUMN, SYMBOL_COLUMN, SIDE_COLUMN, AVG_PRICE_COLUMN, CUM_QTY_COLUMN, NOTIONAL_VALUE_COLUMN, TEXT_COLUMN, USER_ACK_COLUMN]
  }

  map.set(ECN_RISK_SUMMARY, ECN_RISK_CONFIG);
  map.set(IDQS_RISK_SUMMARY, IDQS_RISK_CONFIG);
  map.set(UNMATCHED_TRADES, UNMATCHED_TRADES_CONFIG);
  map.set(UNMATCHED_OTHER_TRADES, UNMATCHED_OTHER_TRADES_CONFIG);
  map.set(LOCK_CROSS_QUOTES, LOCK_CROSS_QUOTES_CONFIG);
  map.set(L1_TRADES, L1_TRADES_CONFIG);
  map.set(TRF_TRADES, TRF_TRADES_CONFIG);
  return map;

}

const getDashboardTableConfig = (internalApiUrl) => {
  const map = new Map();
  const ECN_TRADE_SYMBOL_SUMMARY_CONFIG = {
    identifier: ECN_TRADE_SYMBOL_SUMMARY,
    ws: `wss://${internalApiUrl}/ws/ecn/trade/symbol/summary`,
    api: '/internal/dashboard-data/ecn/trade/symbol/summary',
    historicApi: '/internal/dashboard-data/ecn/trade/symbol/summary/historic',
    downloadApi: '/internal/dashboard-data/download/ecn/trade/symbol/summary/historic/download',
    lastUpdatedField: 'lastExecTime',
    totalField: 'totalTradeCount',
    summaryGroupTitleColumn: SYMBOL_COLUMN,
    summaryGroupDataColumn: TRADES_COLUMN,
    header: 'Top Symbols By Trades',
    columns: [SYMBOL_COLUMN, TRADES_COLUMN, VOLUME_COLUMN, NOTIONAL_COLUMN]

  };
  const ECN_TRADE_MMID_SUMMARY_CONFIG = {
    identifier: ECN_TRADE_MMID_SUMMARY,
    ws: `wss://${internalApiUrl}/ws/ecn/trade/mmid/summary`,
    api: '/internal/dashboard-data/ecn/trade/mmid/summary',
    historicApi: '/internal/dashboard-data/ecn/trade/mmid/summary/historic',
    downloadApi: '/internal/dashboard-data/download/ecn/trade/mmid/summary/historic/download',
    lastUpdatedField: 'lastExecTime',
    totalField: 'totalTradeCount',
    summaryGroupTitleColumn: MPID_COLUMN,
    summaryGroupDataColumn: TRADES_COLUMN,
    header: 'Top MPIDs By Trades',
    columns: [MPID_COLUMN, TRADES_COLUMN, VOLUME_COLUMN, NOTIONAL_COLUMN]

  };
  const ECN_ORDER_SYMBOL_SUMMARY_CONFIG = {
    identifier: ECN_ORDER_SYMBOL_SUMMARY,
    ws: `wss://${internalApiUrl}/ws/ecn/order/symbol/summary`,
    api: '/internal/dashboard-data/ecn/order/symbol/summary',
    historicApi: '/internal/dashboard-data/ecn/order/symbol/summary/historic',
    downloadApi: '/internal/dashboard-data/download/ecn/order/symbol/summary/historic/download',
    lastUpdatedField: 'lastOrderTime',
    header: 'Top Symbols By Orders',
    totalField: 'totalOrderCount',
    summaryGroupTitleColumn: SYMBOL_COLUMN,
    summaryGroupDataColumn: ORDERS_COLUMN,
    columns: [SYMBOL_COLUMN, ORDERS_COLUMN]

  };
  const ECN_ORDER_MMID_SUMMARY_CONFIG = {
    identifier: ECN_ORDER_MMID_SUMMARY,
    ws: `wss://${internalApiUrl}/ws/ecn/order/mmid/summary`,
    api: '/internal/dashboard-data/ecn/order/mmid/summary',
    historicApi: '/internal/dashboard-data/ecn/order/mmid/summary/historic',
    downloadApi: '/internal/dashboard-data/download/ecn/order/mmid/summary/historic/download',
    summaryGroupTitleColumn: MPID_COLUMN,
    summaryGroupDataColumn: ORDERS_COLUMN,
    lastUpdatedField: 'lastOrderTime',
    totalField: 'totalOrderCount',
    header: 'Top MPIDs By Orders',
    columns: [MPID_COLUMN, ORDERS_COLUMN]

  };
  const ECN_OPEN_ORDER_SYMBOL_SUMMARY_CONFIG = {
    identifier: ECN_OPEN_ORDER_SYMBOL_SUMMARY,
    ws: `wss://${internalApiUrl}/ws/ecn/open/order/symbol/summary`,
    api: '/internal/dashboard-data/ecn/open/order/symbol/summary',
    historicApi: '/internal/dashboard-data/ecn/open/order/symbol/summary/historic',
    downloadApi: '/internal/dashboard-data/download/ecn/open/order/symbol/summary/historic/download',
    lastUpdatedField: 'lastOrderTime',
    header: 'Open Orders By Symbol',
    totalField: 'totalOpenOrderCount',
    summaryGroupTitleColumn: SYMBOL_COLUMN,
    summaryGroupDataColumn: OPEN_ORDERS_COLUMN,
    columns: [SYMBOL_COLUMN, OPEN_ORDERS_COLUMN]

  };

  const ECN_OPEN_ORDER_MMID_SUMMARY_CONFIG = {
    identifier: ECN_OPEN_ORDER_MMID_SUMMARY,
    ws: `wss://${internalApiUrl}/ws/ecn/open/order/mpid/summary`,
    api: '/internal/dashboard-data/ecn/open/order/mpid/summary',
    historicApi: '/internal/dashboard-data/ecn/open/order/mpid/summary/historic',
    downloadApi: '/internal/dashboard-data/download/ecn/open/order/mpid/summary/historic/download',
    lastUpdatedField: 'lastOrderTime',
    totalField: 'totalOpenOrderCount',
    summaryGroupTitleColumn: MPID_COLUMN,
    summaryGroupDataColumn: OPEN_ORDERS_COLUMN,
    header: 'Open Orders By MPID',
    columns: [MPID_COLUMN, OPEN_ORDERS_COLUMN]

  };

  const ECN_UNENTITLED_SYMBOLS_CONFIG = {
    identifier: ECN_UNENTITLED_SYMBOLS_SUMMARY,
    ws: `wss://${internalApiUrl}/ws/ecn/order/unentitled/symbol/summary`,
    api: '/internal/dashboard-data/ecn/order/unentitled/symbol/summary',
    historicApi: '/internal/dashboard-data/ecn/order/unentitled/symbol/summary/historic',
    downloadApi: '/internal/dashboard-data/download/ecn/order/unentitled/symbol/summary/historic/download',
    lastUpdatedField: 'lastOrderTime',
    totalField: 'totalUnentitledOrderCount',
    summaryGroupTitleColumn: SYMBOL_COLUMN,
    summaryGroupDataColumn: ORDERS_COLUMN,
    header: 'Unentitled Symbols',
    columns: [SYMBOL_COLUMN, ORDERS_COLUMN]
  };

  const ECN_ORDER_TRADE_RATIO_SUMMARY_CONFIG = {
    identifier: ECN_ORDER_TRADE_RATIO_SUMMARY,
    ws: `wss://${internalApiUrl}/ws/ecn/order/trade/ratio/metric`,
    api: '/internal/dashboard-data/ecn/order/trade/ratio/metric',
    historicApi: '/internal/dashboard-data/ecn/order/trade/ratio/metric/historic',
    downloadApi: '/internal/dashboard-data/download/ecn/order/trade/ratio/metric/historic/download',
    lastUpdatedField: 'lastOrderTime',
    summaryGroupTitleColumn: SYMBOL_COLUMN,
    summaryGroupDataColumn: ORDERS_TRADE_RATIO_COLUMN,
    header: 'Order/Trade Ratio',
    columns: [SYMBOL_COLUMN, ORDERS_TRADE_RATIO_COLUMN]

  };

  // ATS
  const ATS_TRADE_SYMBOL_SUMMARY_CONFIG = {
    identifier: ATS_TRADE_SYMBOL_SUMMARY,
    ws: `wss://${internalApiUrl}/ws/ats/trade/symbol/summary`,
    api: '/internal/dashboard-data/ats/trade/symbol/summary',
    historicApi: '/internal/dashboard-data/ats/trade/symbol/summary/historic',
    downloadApi: '/internal/dashboard-data/download/ats/trade/symbol/summary/historic/download',
    lastUpdatedField: 'lastExecTime',
    totalField: 'totalTradeCount',
    summaryGroupTitleColumn: SYMBOL_COLUMN,
    summaryGroupDataColumn: TRADES_COLUMN,
    header: 'Top Symbols By Trades',
    columns: [SYMBOL_COLUMN, TRADES_COLUMN, VOLUME_COLUMN, NOTIONAL_COLUMN]

  };
  const ATS_TRADE_MMID_SUMMARY_CONFIG = {
    identifier: ATS_TRADE_MMID_SUMMARY,
    ws: `wss://${internalApiUrl}/ws/ats/trade/mmid/summary`,
    api: '/internal/dashboard-data/ats/trade/mmid/summary',
    historicApi: '/internal/dashboard-data/ats/trade/mmid/summary/historic',
    downloadApi: '/internal/dashboard-data/download/ats/trade/mmid/summary/historic/download',
    lastUpdatedField: 'lastExecTime',
    totalField: 'totalTradeCount',
    summaryGroupTitleColumn: MMID_COLUMN,
    summaryGroupDataColumn: TRADES_COLUMN,
    header: 'Top MPIDs By Trades',
    columns: [MMID_COLUMN, TRADES_COLUMN, VOLUME_COLUMN, NOTIONAL_COLUMN]

  };
  const ATS_QUOTE_SYMBOL_SUMMARY_CONFIG = {
    identifier: ATS_QUOTE_SYMBOL_SUMMARY,
    ws: `wss://${internalApiUrl}/ws/ats/quote/symbol/summary`,
    api: '/internal/dashboard-data/ats/quote/symbol/summary',
    historicApi: '/internal/dashboard-data/ats/quote/symbol/summary/historic',
    downloadApi: '/internal/dashboard-data/download/ats/quote/symbol/summary/historic/download',
    lastUpdatedField: 'lastQuoteTime',
    totalField: 'totalQuoteCount',
    summaryGroupTitleColumn: SYMBOL_COLUMN,
    summaryGroupDataColumn: QUOTES_COLUMN,
    header: 'Top Symbols By Quotes Today',
    historicHeader: 'Top Symbols By Quotes',
    columns: [SYMBOL_COLUMN, QUOTES_COLUMN]

  };
  const ATS_QUOTE_MMID_SUMMARY_CONFIG = {
    identifier: ATS_QUOTE_MMID_SUMMARY,
    ws: `wss://${internalApiUrl}/ws/ats/quote/mmid/summary`,
    api: '/internal/dashboard-data/ats/quote/mmid/summary',
    historicApi: '/internal/dashboard-data/ats/quote/mmid/summary/historic',
    downloadApi: '/internal/dashboard-data/download/ats/quote/mmid/summary/historic/download',
    lastUpdatedField: 'lastQuoteTime',
    totalField: 'totalQuoteCount',
    summaryGroupTitleColumn: MMID_COLUMN,
    summaryGroupDataColumn: QUOTES_COLUMN,
    header: 'Top MPIDs By Quotes Today',
    historicHeader: 'Top MPIDs By Quotes',
    columns: [MMID_COLUMN, QUOTES_COLUMN]

  };

  const ATS_QUOTE_SYMBOL_FREQ_SUMMARY_CONFIG = {
    identifier: ATS_QUOTE_FREQ_SYMBOL_SUMMARY,
    ws: `wss://${internalApiUrl}/ws/ats/quote/symbol/update/frequency/metric`,
    api: '/internal/dashboard-data/ats/quote/symbol/update/frequency/metric',
    lastUpdatedField: 'lastQuoteTime',
    summaryGroupTitleColumn: SYMBOL_COLUMN,
    summaryGroupDataColumn: QUOTES_COLUMN,
    header: 'Top Symbols by Quotes (Last 5 Min.)',
    columns: [SYMBOL_COLUMN, QUOTES_COLUMN]

  };
  const ATS_QUOTE_MMID_FREQ_SUMMARY_CONFIG = {
    identifier: ATS_QUOTE_FREQ_MMID_SUMMARY,
    ws: `wss://${internalApiUrl}/ws/ats/quote/mmid/update/frequency/metric`,
    api: '/internal/dashboard-data/ats/quote/mmid/update/frequency/metric',
    lastUpdatedField: 'lastQuoteTime',
    summaryGroupTitleColumn: MMID_COLUMN,
    summaryGroupDataColumn: QUOTES_COLUMN,
    header: 'Top MPIDs by Quotes (Last 5 Min.)',
    columns: [MMID_COLUMN, QUOTES_COLUMN]

  };

  const TDDS_TRADE_RATIO_SUMMARY_CONFIG = {
    identifier: TDDS_TRADE_RATIO_SUMMARY,
    ws: `wss://${internalApiUrl}/ws/tdds/trade/ratio/metric`,
    api: '/internal/dashboard-data/tdds/trade/ratio/metric',
    historicApi: '/internal/dashboard-data/tdds/trade/ratio/metric/historic',
    downloadApi: '/internal/dashboard-data/download/tdds/trade/ratio/metric/historic/download',
    lastUpdatedField: 'lastExecTime',
    summaryGroupTitleColumn: SYMBOL_COLUMN,
    summaryGroupDataCustomColumns: [OTCXN_TRADE_COLUMN, ATS_TRADE_COLUMN, TDDS_TRADE_COLUMN],
    header: 'Top Symbols By Trades',
    columns: [SYMBOL_COLUMN, OTCXN_TRADE_COLUMN, OTCXN_TRADE_RATIO_COLUMN, ATS_TRADE_COLUMN, ATS_TRADE_RATIO_COLUMN, TDDS_TRADE_COLUMN]

  };

  const TDDS_SHARE_RATIO_SUMMARY_CONFIG = {
    identifier: TDDS_SHARE_RATIO_SUMMARY,
    ws: `wss://${internalApiUrl}/ws/tdds/shares/ratio/metric`,
    api: '/internal/dashboard-data/tdds/shares/ratio/metric',
    historicApi: '/internal/dashboard-data/tdds/shares/ratio/metric/historic',
    downloadApi: '/internal/dashboard-data/download/tdds/shares/ratio/metric/historic/download',
    lastUpdatedField: 'lastExecTime',
    summaryGroupTitleColumn: SYMBOL_COLUMN,
    summaryGroupDataCustomColumns: [OTCXN_SHARE_COLUMN, ATS_SHARE_COLUMN, TDDS_SHARE_COLUMN],
    header: 'Top Symbols By Shares',
    columns: [SYMBOL_COLUMN, OTCXN_SHARE_COLUMN, OTCXN_SHARE_RATIO_COLUMN, ATS_SHARE_COLUMN, ATS_SHARE_RATIO_COLUMN, TDDS_SHARE_COLUMN]

  };

  const TDDS_NOTIONAL_RATIO_SUMMARY_CONFIG = {
    identifier: TDDS_NOTIONAL_RATIO_SUMMARY,
    ws: `wss://${internalApiUrl}/ws/tdds/notional/ratio/metric`,
    api: '/internal/dashboard-data/tdds/notional/ratio/metric',
    historicApi: '/internal/dashboard-data/tdds/notional/ratio/metric/historic',
    downloadApi: '/internal/dashboard-data/download/tdds/notional/ratio/metric/historic/download',
    lastUpdatedField: 'lastExecTime',
    summaryGroupTitleColumn: SYMBOL_COLUMN,
    summaryGroupDataCustomColumns: [OTCXN_NOTIONAL_COLUMN, ATS_NOTIONAL_COLUMN, TDDS_NOTIONAL_COLUMN],
    header: 'Top Symbols By Notional',
    columns: [SYMBOL_COLUMN, OTCXN_NOTIONAL_COLUMN, OTCXN_NOTIONAL_RATIO_COLUMN, ATS_NOTIONAL_COLUMN, ATS_NOTIONAL_RATIO_COLUMN, TDDS_NOTIONAL_COLUMN]

  };


// IDQS DAY


const IDQS_DAY_TRADE_SYMBOL_SUMMARY_CONFIG = {
  identifier: IDQS_DAY_TRADE_SYMBOL_SUMMARY,
  ws: `wss://${internalApiUrl}/ws/idqs/trade/symbol/summary`,
  api: '/internal/dashboard-data/idqs/trade/symbol/summary',
  historicApi: '/internal/dashboard-data/idqs/trade/symbol/summary/historic',
  downloadApi: '/internal/dashboard-data/download/idqs/trade/symbol/summary/historic/download',
  lastUpdatedField: 'lastExecTime',
  totalField: 'totalTradeCount',
  summaryGroupTitleColumn: SYMBOL_COLUMN,
  summaryGroupDataColumn: TRADES_COLUMN,
  header: 'Top Symbols By Trades',
  columns: [SYMBOL_COLUMN, TRADES_COLUMN, VOLUME_COLUMN, NOTIONAL_COLUMN]

};
const IDQS_DAY_TRADE_MMID_SUMMARY_CONFIG = {
  identifier: IDQS_DAY_TRADE_MMID_SUMMARY,
  ws: `wss://${internalApiUrl}/ws/idqs/trade/mmid/summary`,
  api: '/internal/dashboard-data/idqs/trade/mmid/summary',
  historicApi: '/internal/dashboard-data/idqs/trade/mmid/summary/historic',
  downloadApi: '/internal/dashboard-data/download/idqs/trade/mmid/summary/historic/download',
  lastUpdatedField: 'lastExecTime',
  totalField: 'totalTradeCount',
  summaryGroupTitleColumn: MPID_COLUMN,
  summaryGroupDataColumn: TRADES_COLUMN,
  header: 'Top MPIDs By Trades',
  columns: [MPID_COLUMN, TRADES_COLUMN, VOLUME_COLUMN, NOTIONAL_COLUMN]

};
const IDQS_DAY_ORDER_SYMBOL_SUMMARY_CONFIG = {
  identifier: IDQS_DAY_ORDER_SYMBOL_SUMMARY,
  ws: `wss://${internalApiUrl}/ws/idqs/order/symbol/summary`,
  api: '/internal/dashboard-data/idqs/order/symbol/summary',
  historicApi: '/internal/dashboard-data/idqs/order/symbol/summary/historic',
  downloadApi: '/internal/dashboard-data/download/idqs/order/symbol/summary/historic/download',
  lastUpdatedField: 'lastOrderTime',
  header: 'Top Symbols By Orders',
  totalField: 'totalOrderCount',
  summaryGroupTitleColumn: SYMBOL_COLUMN,
  summaryGroupDataColumn: ORDERS_COLUMN,
  columns: [SYMBOL_COLUMN, ORDERS_COLUMN]

};
const IDQS_DAY_ORDER_MMID_SUMMARY_CONFIG = {
  identifier: IDQS_DAY_ORDER_MMID_SUMMARY,
  ws: `wss://${internalApiUrl}/ws/idqs/order/mmid/summary`,
  api: '/internal/dashboard-data/idqs/order/mmid/summary',
  historicApi: '/internal/dashboard-data/idqs/order/mmid/summary/historic',
  downloadApi: '/internal/dashboard-data/download/idqs/order/mmid/summary/historic/download',
  summaryGroupTitleColumn: MPID_COLUMN,
  summaryGroupDataColumn: ORDERS_COLUMN,
  lastUpdatedField: 'lastOrderTime',
  totalField: 'totalOrderCount',
  header: 'Top MPIDs By Orders',
  columns: [MPID_COLUMN, ORDERS_COLUMN]

};
const IDQS_DAY_OPEN_ORDER_SYMBOL_SUMMARY_CONFIG = {
  identifier: IDQS_DAY_OPEN_ORDER_SYMBOL_SUMMARY,
  ws: `wss://${internalApiUrl}/ws/idqs/open/order/symbol/summary`,
  api: '/internal/dashboard-data/idqs/open/order/symbol/summary',
  historicApi: '/internal/dashboard-data/idqs/open/order/symbol/summary/historic',
  downloadApi: '/internal/dashboard-data/download/idqs/open/order/symbol/summary/historic/download',
  lastUpdatedField: 'lastOrderTime',
  header: 'Open Orders By Symbol',
  totalField: 'totalOpenOrderCount',
  summaryGroupTitleColumn: SYMBOL_COLUMN,
  summaryGroupDataColumn: OPEN_ORDERS_COLUMN,
  columns: [SYMBOL_COLUMN, OPEN_ORDERS_COLUMN]

};

const IDQS_DAY_OPEN_ORDER_MMID_SUMMARY_CONFIG = {
  identifier: IDQS_DAY_OPEN_ORDER_MMID_SUMMARY,
  ws: `wss://${internalApiUrl}/ws/idqs/open/order/mpid/summary`,
  api: '/internal/dashboard-data/idqs/open/order/mpid/summary',
  historicApi: '/internal/dashboard-data/idqs/open/order/mpid/summary/historic',
  downloadApi: '/internal/dashboard-data/download/idqs/open/order/mpid/summary/historic/download',
  lastUpdatedField: 'lastOrderTime',
  totalField: 'totalOpenOrderCount',
  summaryGroupTitleColumn: MPID_COLUMN,
  summaryGroupDataColumn: OPEN_ORDERS_COLUMN,
  header: 'Open Orders By MPID',
  columns: [MPID_COLUMN, OPEN_ORDERS_COLUMN]

};

const IDQS_DAY_UNENTITLED_SYMBOLS_CONFIG = {
  identifier: IDQS_DAY_UNENTITLED_SYMBOLS_SUMMARY,
  ws: `wss://${internalApiUrl}/ws/idqs/order/unentitled/symbol/summary`,
  api: '/internal/dashboard-data/idqs/order/unentitled/symbol/summary',
  historicApi: '/internal/dashboard-data/idqs/order/unentitled/symbol/summary/historic',
  downloadApi: '/internal/dashboard-data/download/idqs/order/unentitled/symbol/summary/historic/download',
  lastUpdatedField: 'lastOrderTime',
  totalField: 'totalUnentitledOrderCount',
  summaryGroupTitleColumn: SYMBOL_COLUMN,
  summaryGroupDataColumn: ORDERS_COLUMN,
  header: 'Unentitled Symbols',
  columns: [SYMBOL_COLUMN, ORDERS_COLUMN]
};

const IDQS_DAY_ORDER_TRADE_RATIO_SUMMARY_CONFIG = {
  identifier: IDQS_DAY_ORDER_TRADE_RATIO_SUMMARY,
  ws: `wss://${internalApiUrl}/ws/idqs/order/trade/ratio/metric`,
  api: '/internal/dashboard-data/idqs/order/trade/ratio/metric',
  historicApi: '/internal/dashboard-data/idqs/order/trade/ratio/metric/historic',
  downloadApi: '/internal/dashboard-data/download/idqs/order/trade/ratio/metric/historic/download',
  lastUpdatedField: 'lastOrderTime',
  summaryGroupTitleColumn: SYMBOL_COLUMN,
  summaryGroupDataColumn: ORDERS_TRADE_RATIO_COLUMN,
  header: 'Order/Trade Ratio',
  columns: [SYMBOL_COLUMN, ORDERS_TRADE_RATIO_COLUMN]

};


// IDQS NIGHT

const IDQS_NIGHT_TRADE_SYMBOL_SUMMARY_CONFIG = {
  identifier: IDQS_NIGHT_TRADE_SYMBOL_SUMMARY,
  ws: `wss://${internalApiUrl}/ws/idqs/overnight/trade/symbol/summary`,
  api: '/internal/dashboard-data/idqs/overnight/trade/symbol/summary',
  historicApi: '/internal/dashboard-data/idqs/overnight/trade/symbol/summary/historic',
  downloadApi: '/internal/dashboard-data/download/idqs/overnight/trade/symbol/summary/historic/download',
  lastUpdatedField: 'lastExecTime',
  totalField: 'totalTradeCount',
  summaryGroupTitleColumn: SYMBOL_COLUMN,
  summaryGroupDataColumn: TRADES_COLUMN,
  header: 'Top Symbols By Trades',
  columns: [SYMBOL_COLUMN, TRADES_COLUMN, VOLUME_COLUMN, NOTIONAL_COLUMN]

};
const IDQS_NIGHT_TRADE_MMID_SUMMARY_CONFIG = {
  identifier: IDQS_NIGHT_TRADE_MMID_SUMMARY,
  ws: `wss://${internalApiUrl}/ws/idqs/overnight/trade/mmid/summary`,
  api: '/internal/dashboard-data/idqs/overnight/trade/mmid/summary',
  historicApi: '/internal/dashboard-data/idqs/overnight/trade/mmid/summary/historic',
  downloadApi: '/internal/dashboard-data/download/idqs/overnight/trade/mmid/summary/historic/download',
  lastUpdatedField: 'lastExecTime',
  totalField: 'totalTradeCount',
  summaryGroupTitleColumn: MPID_COLUMN,
  summaryGroupDataColumn: TRADES_COLUMN,
  header: 'Top MPIDs By Trades',
  columns: [MPID_COLUMN, TRADES_COLUMN, VOLUME_COLUMN, NOTIONAL_COLUMN]

};
const IDQS_NIGHT_ORDER_SYMBOL_SUMMARY_CONFIG = {
  identifier: IDQS_NIGHT_ORDER_SYMBOL_SUMMARY,
  ws: `wss://${internalApiUrl}/ws/idqs/overnight/order/symbol/summary`,
  api: '/internal/dashboard-data/idqs/overnight/order/symbol/summary',
  historicApi: '/internal/dashboard-data/idqs/overnight/order/symbol/summary/historic',
  downloadApi: '/internal/dashboard-data/download/idqs/overnight/order/symbol/summary/historic/download',
  lastUpdatedField: 'lastOrderTime',
  header: 'Top Symbols By Orders',
  totalField: 'totalOrderCount',
  summaryGroupTitleColumn: SYMBOL_COLUMN,
  summaryGroupDataColumn: ORDERS_COLUMN,
  columns: [SYMBOL_COLUMN, ORDERS_COLUMN]

};
const IDQS_NIGHT_ORDER_MMID_SUMMARY_CONFIG = {
  identifier: IDQS_NIGHT_ORDER_MMID_SUMMARY,
  ws: `wss://${internalApiUrl}/ws/idqs/overnight/order/mmid/summary`,
  api: '/internal/dashboard-data/idqs/overnight/order/mmid/summary',
  historicApi: '/internal/dashboard-data/idqs/overnight/order/mmid/summary/historic',
  downloadApi: '/internal/dashboard-data/download/idqs/overnight/order/mmid/summary/historic/download',
  summaryGroupTitleColumn: MPID_COLUMN,
  summaryGroupDataColumn: ORDERS_COLUMN,
  lastUpdatedField: 'lastOrderTime',
  totalField: 'totalOrderCount',
  header: 'Top MPIDs By Orders',
  columns: [MPID_COLUMN, ORDERS_COLUMN]

};
const IDQS_NIGHT_OPEN_ORDER_SYMBOL_SUMMARY_CONFIG = {
  identifier: IDQS_NIGHT_OPEN_ORDER_SYMBOL_SUMMARY,
  ws: `wss://${internalApiUrl}/ws/idqs/overnight/open/order/symbol/summary`,
  api: '/internal/dashboard-data/idqs/overnight/open/order/symbol/summary',
  historicApi: '/internal/dashboard-data/idqs/overnight/open/order/symbol/summary/historic',
  downloadApi: '/internal/dashboard-data/download/idqs/overnight/open/order/symbol/summary/historic/download',
  lastUpdatedField: 'lastOrderTime',
  header: 'Open Orders By Symbol',
  totalField: 'totalOpenOrderCount',
  summaryGroupTitleColumn: SYMBOL_COLUMN,
  summaryGroupDataColumn: OPEN_ORDERS_COLUMN,
  columns: [SYMBOL_COLUMN, OPEN_ORDERS_COLUMN]

};

const IDQS_NIGHT_OPEN_ORDER_MMID_SUMMARY_CONFIG = {
  identifier: IDQS_NIGHT_OPEN_ORDER_MMID_SUMMARY,
  ws: `wss://${internalApiUrl}/ws/idqs/overnight/open/order/mpid/summary`,
  api: '/internal/dashboard-data/idqs/overnight/open/order/mpid/summary',
  historicApi: '/internal/dashboard-data/idqs/overnight/open/order/mpid/summary/historic',
  downloadApi: '/internal/dashboard-data/download/idqs/overnight/open/order/mpid/summary/historic/download',
  lastUpdatedField: 'lastOrderTime',
  totalField: 'totalOpenOrderCount',
  summaryGroupTitleColumn: MPID_COLUMN,
  summaryGroupDataColumn: OPEN_ORDERS_COLUMN,
  header: 'Open Orders By MPID',
  columns: [MPID_COLUMN, OPEN_ORDERS_COLUMN]

};

const IDQS_NIGHT_UNENTITLED_SYMBOLS_CONFIG = {
  identifier: IDQS_NIGHT_UNENTITLED_SYMBOLS_SUMMARY,
  ws: `wss://${internalApiUrl}/ws/idqs/overnight/order/unentitled/symbol/summary`,
  api: '/internal/dashboard-data/idqs/overnight/order/unentitled/symbol/summary',
  historicApi: '/internal/dashboard-data/idqs/overnight/order/unentitled/symbol/summary/historic',
  downloadApi: '/internal/dashboard-data/download/idqs/overnight/order/unentitled/symbol/summary/historic/download',
  lastUpdatedField: 'lastOrderTime',
  totalField: 'totalUnentitledOrderCount',
  summaryGroupTitleColumn: SYMBOL_COLUMN,
  summaryGroupDataColumn: ORDERS_COLUMN,
  header: 'Unentitled Symbols',
  columns: [SYMBOL_COLUMN, ORDERS_COLUMN]
};

const IDQS_NIGHT_ORDER_TRADE_RATIO_SUMMARY_CONFIG = {
  identifier: IDQS_NIGHT_ORDER_TRADE_RATIO_SUMMARY,
  ws: `wss://${internalApiUrl}/ws/idqs/overnight/order/trade/ratio/metric`,
  api: '/internal/dashboard-data/idqs/overnight/order/trade/ratio/metric',
  historicApi: '/internal/dashboard-data/idqs/overnight/order/trade/ratio/metric/historic',
  downloadApi: '/internal/dashboard-data/download/idqs/overnight/order/trade/ratio/metric/historic/download',
  lastUpdatedField: 'lastOrderTime',
  summaryGroupTitleColumn: SYMBOL_COLUMN,
  summaryGroupDataColumn: ORDERS_TRADE_RATIO_COLUMN,
  header: 'Order/Trade Ratio',
  columns: [SYMBOL_COLUMN, ORDERS_TRADE_RATIO_COLUMN]

};


// IDQS NMS

const IDQS_NMS_TRADE_SYMBOL_SUMMARY_CONFIG = {
  identifier: IDQS_NMS_TRADE_SYMBOL_SUMMARY,
  ws: `wss://${internalApiUrl}/ws/idqs/moon/trade/symbol/summary`,
  api: '/internal/dashboard-data/idqs/moon/trade/symbol/summary',
  historicApi: '/internal/dashboard-data/idqs/moon/trade/symbol/summary/historic',
  downloadApi: '/internal/dashboard-data/download/idqs/moon/trade/symbol/summary/historic/download',
  lastUpdatedField: 'lastExecTime',
  totalField: 'totalTradeCount',
  summaryGroupTitleColumn: SYMBOL_COLUMN,
  summaryGroupDataColumn: TRADES_COLUMN,
  header: 'Top Symbols By Trades',
  columns: [SYMBOL_COLUMN, TRADES_COLUMN, VOLUME_COLUMN, NOTIONAL_COLUMN]

};
const IDQS_NMS_TRADE_MMID_SUMMARY_CONFIG = {
  identifier: IDQS_NMS_TRADE_MMID_SUMMARY,
  ws: `wss://${internalApiUrl}/ws/idqs/moon/trade/mmid/summary`,
  api: '/internal/dashboard-data/idqs/moon/trade/mmid/summary',
  historicApi: '/internal/dashboard-data/idqs/moon/trade/mmid/summary/historic',
  downloadApi: '/internal/dashboard-data/download/idqs/moon/trade/mmid/summary/historic/download',
  lastUpdatedField: 'lastExecTime',
  totalField: 'totalTradeCount',
  summaryGroupTitleColumn: MPID_COLUMN,
  summaryGroupDataColumn: TRADES_COLUMN,
  header: 'Top MPIDs By Trades',
  columns: [MPID_COLUMN, TRADES_COLUMN, VOLUME_COLUMN, NOTIONAL_COLUMN]

};
const IDQS_NMS_ORDER_SYMBOL_SUMMARY_CONFIG = {
  identifier: IDQS_NMS_ORDER_SYMBOL_SUMMARY,
  ws: `wss://${internalApiUrl}/ws/idqs/moon/order/symbol/summary`,
  api: '/internal/dashboard-data/idqs/moon/order/symbol/summary',
  historicApi: '/internal/dashboard-data/idqs/moon/order/symbol/summary/historic',
  downloadApi: '/internal/dashboard-data/download/idqs/moon/order/symbol/summary/historic/download',
  lastUpdatedField: 'lastOrderTime',
  header: 'Top Symbols By Orders',
  totalField: 'totalOrderCount',
  summaryGroupTitleColumn: SYMBOL_COLUMN,
  summaryGroupDataColumn: ORDERS_COLUMN,
  columns: [SYMBOL_COLUMN, ORDERS_COLUMN]

};
const IDQS_NMS_ORDER_MMID_SUMMARY_CONFIG = {
  identifier: IDQS_NMS_ORDER_MMID_SUMMARY,
  ws: `wss://${internalApiUrl}/ws/idqs/moon/order/mmid/summary`,
  api: '/internal/dashboard-data/idqs/moon/order/mmid/summary',
  historicApi: '/internal/dashboard-data/idqs/moon/order/mmid/summary/historic',
  downloadApi: '/internal/dashboard-data/download/idqs/moon/order/mmid/summary/historic/download',
  summaryGroupTitleColumn: MPID_COLUMN,
  summaryGroupDataColumn: ORDERS_COLUMN,
  lastUpdatedField: 'lastOrderTime',
  totalField: 'totalOrderCount',
  header: 'Top MPIDs By Orders',
  columns: [MPID_COLUMN, ORDERS_COLUMN]

};
const IDQS_NMS_OPEN_ORDER_SYMBOL_SUMMARY_CONFIG = {
  identifier: IDQS_NMS_OPEN_ORDER_SYMBOL_SUMMARY,
  ws: `wss://${internalApiUrl}/ws/idqs/moon/open/order/symbol/summary`,
  api: '/internal/dashboard-data/idqs/moon/open/order/symbol/summary',
  historicApi: '/internal/dashboard-data/idqs/moon/open/order/symbol/summary/historic',
  downloadApi: '/internal/dashboard-data/download/idqs/moon/open/order/symbol/summary/historic/download',
  lastUpdatedField: 'lastOrderTime',
  header: 'Open Orders By Symbol',
  totalField: 'totalOpenOrderCount',
  summaryGroupTitleColumn: SYMBOL_COLUMN,
  summaryGroupDataColumn: OPEN_ORDERS_COLUMN,
  columns: [SYMBOL_COLUMN, OPEN_ORDERS_COLUMN]

};

const IDQS_NMS_OPEN_ORDER_MMID_SUMMARY_CONFIG = {
  identifier: IDQS_NMS_OPEN_ORDER_MMID_SUMMARY,
  ws: `wss://${internalApiUrl}/ws/idqs/moon/open/order/mpid/summary`,
  api: '/internal/dashboard-data/idqs/moon/open/order/mpid/summary',
  historicApi: '/internal/dashboard-data/idqs/moon/open/order/mpid/summary/historic',
  downloadApi: '/internal/dashboard-data/download/idqs/moon/open/order/mpid/summary/historic/download',
  lastUpdatedField: 'lastOrderTime',
  totalField: 'totalOpenOrderCount',
  summaryGroupTitleColumn: MPID_COLUMN,
  summaryGroupDataColumn: OPEN_ORDERS_COLUMN,
  header: 'Open Orders By MPID',
  columns: [MPID_COLUMN, OPEN_ORDERS_COLUMN]

};

const IDQS_NMS_UNENTITLED_SYMBOLS_CONFIG = {
  identifier: IDQS_NMS_UNENTITLED_SYMBOLS_SUMMARY,
  ws: `wss://${internalApiUrl}/ws/idqs/moon/order/unentitled/symbol/summary`,
  api: '/internal/dashboard-data/idqs/moon/order/unentitled/symbol/summary',
  historicApi: '/internal/dashboard-data/idqs/moon/order/unentitled/symbol/summary/historic',
  downloadApi: '/internal/dashboard-data/download/idqs/moon/order/unentitled/symbol/summary/historic/download',
  lastUpdatedField: 'lastOrderTime',
  totalField: 'totalUnentitledOrderCount',
  summaryGroupTitleColumn: SYMBOL_COLUMN,
  summaryGroupDataColumn: ORDERS_COLUMN,
  header: 'Unentitled Symbols',
  columns: [SYMBOL_COLUMN, ORDERS_COLUMN]
};

const IDQS_NMS_ORDER_TRADE_RATIO_SUMMARY_CONFIG = {
  identifier: IDQS_NMS_ORDER_TRADE_RATIO_SUMMARY,
  ws: `wss://${internalApiUrl}/ws/idqs/moon/order/trade/ratio/metric`,
  api: '/internal/dashboard-data/idqs/moon/order/trade/ratio/metric',
  historicApi: '/internal/dashboard-data/idqs/moon/order/trade/ratio/metric/historic',
  downloadApi: '/internal/dashboard-data/download/idqs/moon/order/trade/ratio/metric/historic/download',
  lastUpdatedField: 'lastOrderTime',
  summaryGroupTitleColumn: SYMBOL_COLUMN,
  summaryGroupDataColumn: ORDERS_TRADE_RATIO_COLUMN,
  header: 'Order/Trade Ratio',
  columns: [SYMBOL_COLUMN, ORDERS_TRADE_RATIO_COLUMN]

};

  map.set(ECN_TRADE_SYMBOL_SUMMARY, ECN_TRADE_SYMBOL_SUMMARY_CONFIG);
  map.set(ECN_TRADE_MMID_SUMMARY, ECN_TRADE_MMID_SUMMARY_CONFIG);
  map.set(ECN_ORDER_SYMBOL_SUMMARY, ECN_ORDER_SYMBOL_SUMMARY_CONFIG);
  map.set(ECN_ORDER_MMID_SUMMARY, ECN_ORDER_MMID_SUMMARY_CONFIG);
  map.set(ECN_OPEN_ORDER_SYMBOL_SUMMARY, ECN_OPEN_ORDER_SYMBOL_SUMMARY_CONFIG);
  map.set(ECN_OPEN_ORDER_MMID_SUMMARY, ECN_OPEN_ORDER_MMID_SUMMARY_CONFIG);
  map.set(ECN_UNENTITLED_SYMBOLS_SUMMARY, ECN_UNENTITLED_SYMBOLS_CONFIG);
  map.set(ECN_ORDER_TRADE_RATIO_SUMMARY, ECN_ORDER_TRADE_RATIO_SUMMARY_CONFIG);

  map.set(ATS_TRADE_SYMBOL_SUMMARY, ATS_TRADE_SYMBOL_SUMMARY_CONFIG);
  map.set(ATS_TRADE_MMID_SUMMARY, ATS_TRADE_MMID_SUMMARY_CONFIG);
  map.set(ATS_QUOTE_SYMBOL_SUMMARY, ATS_QUOTE_SYMBOL_SUMMARY_CONFIG);
  map.set(ATS_QUOTE_MMID_SUMMARY, ATS_QUOTE_MMID_SUMMARY_CONFIG);
  map.set(ATS_QUOTE_FREQ_SYMBOL_SUMMARY, ATS_QUOTE_SYMBOL_FREQ_SUMMARY_CONFIG);
  map.set(ATS_QUOTE_FREQ_MMID_SUMMARY, ATS_QUOTE_MMID_FREQ_SUMMARY_CONFIG);

  map.set(TDDS_TRADE_RATIO_SUMMARY, TDDS_TRADE_RATIO_SUMMARY_CONFIG);
  map.set(TDDS_SHARE_RATIO_SUMMARY, TDDS_SHARE_RATIO_SUMMARY_CONFIG);
  map.set(TDDS_NOTIONAL_RATIO_SUMMARY, TDDS_NOTIONAL_RATIO_SUMMARY_CONFIG);

  map.set(IDQS_DAY_TRADE_SYMBOL_SUMMARY, IDQS_DAY_TRADE_SYMBOL_SUMMARY_CONFIG);
  map.set(IDQS_DAY_TRADE_MMID_SUMMARY, IDQS_DAY_TRADE_MMID_SUMMARY_CONFIG);
  map.set(IDQS_DAY_ORDER_SYMBOL_SUMMARY, IDQS_DAY_ORDER_SYMBOL_SUMMARY_CONFIG);
  map.set(IDQS_DAY_ORDER_MMID_SUMMARY, IDQS_DAY_ORDER_MMID_SUMMARY_CONFIG);
  map.set(IDQS_DAY_OPEN_ORDER_SYMBOL_SUMMARY, IDQS_DAY_OPEN_ORDER_SYMBOL_SUMMARY_CONFIG);
  map.set(IDQS_DAY_OPEN_ORDER_MMID_SUMMARY, IDQS_DAY_OPEN_ORDER_MMID_SUMMARY_CONFIG);
  map.set(IDQS_DAY_UNENTITLED_SYMBOLS_SUMMARY, IDQS_DAY_UNENTITLED_SYMBOLS_CONFIG);
  map.set(IDQS_DAY_ORDER_TRADE_RATIO_SUMMARY, IDQS_DAY_ORDER_TRADE_RATIO_SUMMARY_CONFIG);

  map.set(IDQS_NIGHT_TRADE_SYMBOL_SUMMARY, IDQS_NIGHT_TRADE_SYMBOL_SUMMARY_CONFIG);
  map.set(IDQS_NIGHT_TRADE_MMID_SUMMARY, IDQS_NIGHT_TRADE_MMID_SUMMARY_CONFIG);
  map.set(IDQS_NIGHT_ORDER_SYMBOL_SUMMARY, IDQS_NIGHT_ORDER_SYMBOL_SUMMARY_CONFIG);
  map.set(IDQS_NIGHT_ORDER_MMID_SUMMARY, IDQS_NIGHT_ORDER_MMID_SUMMARY_CONFIG);
  map.set(IDQS_NIGHT_OPEN_ORDER_SYMBOL_SUMMARY, IDQS_NIGHT_OPEN_ORDER_SYMBOL_SUMMARY_CONFIG);
  map.set(IDQS_NIGHT_OPEN_ORDER_MMID_SUMMARY, IDQS_NIGHT_OPEN_ORDER_MMID_SUMMARY_CONFIG);
  map.set(IDQS_NIGHT_UNENTITLED_SYMBOLS_SUMMARY, IDQS_NIGHT_UNENTITLED_SYMBOLS_CONFIG);
  map.set(IDQS_NIGHT_ORDER_TRADE_RATIO_SUMMARY, IDQS_NIGHT_ORDER_TRADE_RATIO_SUMMARY_CONFIG);

  map.set(IDQS_NMS_TRADE_SYMBOL_SUMMARY, IDQS_NMS_TRADE_SYMBOL_SUMMARY_CONFIG);
  map.set(IDQS_NMS_TRADE_MMID_SUMMARY, IDQS_NMS_TRADE_MMID_SUMMARY_CONFIG);
  map.set(IDQS_NMS_ORDER_SYMBOL_SUMMARY, IDQS_NMS_ORDER_SYMBOL_SUMMARY_CONFIG);
  map.set(IDQS_NMS_ORDER_MMID_SUMMARY, IDQS_NMS_ORDER_MMID_SUMMARY_CONFIG);
  map.set(IDQS_NMS_OPEN_ORDER_SYMBOL_SUMMARY, IDQS_NMS_OPEN_ORDER_SYMBOL_SUMMARY_CONFIG);
  map.set(IDQS_NMS_OPEN_ORDER_MMID_SUMMARY, IDQS_NMS_OPEN_ORDER_MMID_SUMMARY_CONFIG);
  map.set(IDQS_NMS_UNENTITLED_SYMBOLS_SUMMARY, IDQS_NMS_UNENTITLED_SYMBOLS_CONFIG);
  map.set(IDQS_NMS_ORDER_TRADE_RATIO_SUMMARY, IDQS_NMS_ORDER_TRADE_RATIO_SUMMARY_CONFIG);

  return map;
};

export default getConfig;
